import Points from 'features/points/points'

export default Points
